<template>
  <div>
    <TopBar currentTitle="Prep Terms">
      <b-button type="is-primary" size="is-small" icon-left="plus" @click="createNew">Add Prep Term</b-button>
    </TopBar>
    <div class="page-content">
    <h1 class="page-title">Prep Terms</h1>
    <p class="page-subtitle mb-4">{{ preps.length }} total</p>

    <!-- Table Card -->
    <div class="feeds-card">
      <div class="feeds-card-body compact">
        <b-table
          :data="preps"
          :hoverable="true"
          @click="open">

          <b-table-column field="term" label="Prep Term" searchable sortable v-slot="props">
            <p class="has-text-weight-bold">{{ props.row.term }}</p>
          </b-table-column>

          <b-table-column field="created_at" width=100 label="Created" sortable centered v-slot="props">
            <span class="date-tag">{{ new Date(props.row.created_at).toLocaleDateString() }}</span>
          </b-table-column>

          <b-table-column field="delete" custom-key="actions" width=40 centered v-slot="props">
            <b-button type="is-danger" size="is-small" icon-right="delete" @click.stop="deletePrep(props.row)" />
          </b-table-column>
        </b-table>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/db"
import TopBar from '@/components/layout/TopBar.vue'

const SCROLL_STATE_KEY = 'feeds_list_state_PrepTermListView'

export default {
  name: 'PrepTermListView',
  components: {
    TopBar
  },
  data() {
    return {
      preps: [],
      scrollRestored: false
    }
  },
  watch: {
    preps() {
      if (!this.scrollRestored) {
        this.scrollRestored = true
        this.$nextTick(() => {
          const savedState = sessionStorage.getItem(SCROLL_STATE_KEY)
          if (savedState) {
            const state = JSON.parse(savedState)
            if (state.scrollY > 0) {
              setTimeout(() => window.scrollTo(state.scrollX, state.scrollY), 50)
            }
          }
        })
      }
    }
  },
  firestore: {
    preps: db.collection('prep_terms').orderBy("created_at", "desc")
  },
  methods: {
    createNew() {
      db.collection("prep_terms").add({
        created_at: Date.now(),
        term: "new prep term",
      })
      .then((docRef) => {
        this.$router.push({ name: 'PrepTermView', params: { id: docRef.id } })
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
    },
    open(prep) {
      this.$router.push({ name: 'PrepTermView', params: { id: prep.id } })
    },
    deletePrep(prep) {
      this.$buefy.dialog.confirm({
        title: 'Deleting prep term',
        message: `Are you sure you want to delete prep: <b><i>"${prep.term}"</i></b>? <br /><br />This action cannot be undone.`,
        confirmText: 'Delete Prep',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          db.collection("prep_terms").doc(prep.id)
          .delete()
          .then(() => {
            this.$buefy.toast.open({type: 'is-success', message: `Prep term successfully deleted!`})
          }).catch((error) => {
            this.$buefy.toast.open({type: 'is-danger', message: `Error deleting prep term: ${error}`})
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.date-tag {
  font-size: 12px;
  color: var(--text-secondary);
}
</style>
